function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2FAFF",
  fillOpacity: 0.9,
  d: "M5.00003 7C4.44775 7 4.00003 7.44772 4.00003 8V9.78947C4.00003 10.3418 4.44775 10.7895 5.00003 10.7895H9.31582C9.86811 10.7895 10.3158 11.2372 10.3158 11.7895V24.9474C10.3158 25.4997 10.7635 25.9474 11.3158 25.9474H13.1053C13.6576 25.9474 14.1053 25.4997 14.1053 24.9474V11.7895C14.1053 11.2372 14.553 10.7895 15.1053 10.7895H19.4211C19.9734 10.7895 20.4211 10.3418 20.4211 9.78947V8C20.4211 7.44772 19.9734 7 19.4211 7H5.00003ZM28 14.3158C28 13.7635 27.5523 13.3158 27 13.3158H17.6316C17.0793 13.3158 16.6316 13.7635 16.6316 14.3158V16.1053C16.6316 16.6575 17.0793 17.1053 17.6316 17.1053H19.4211C19.9734 17.1053 20.4211 17.553 20.4211 18.1053V24.9474C20.4211 25.4997 20.8688 25.9474 21.4211 25.9474H23.2106C23.7628 25.9474 24.2106 25.4997 24.2106 24.9474V18.1053C24.2106 17.553 24.6583 17.1053 25.2106 17.1053H27C27.5523 17.1053 28 16.6575 28 16.1053V14.3158Z"
});

function SvgText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.dbad9587.svg";
export { ForwardRef as ReactComponent };